<template>
  <div
    class="RMPE-Layout RMPE-Layout-BackgroundImage"
    :style="{ backgroundImage: `url(${image}`}"
  >
    <div class="columns">
      <div class="column RMPE-Layout-Field">
        <div class="RMPE-Layout-BackgroundImageOverlay">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LayoutMixin from '../mixins/layout-mixin';

export default {
  mixins: [LayoutMixin],

  props: {},

  data() {
    return {};
  },

  computed: {},

  methods: {},
};
</script>

<style scoped lang="scss">
.RMPE-Layout-BackgroundImageOverlay {
  border-radius: 8px;
  position: relative;
  margin: auto;
  width: 95%;
  padding: 0;
  @media screen and (min-width: 768px) {
    width: 100%;
    margin: auto;
    max-width: 780px;
  }
}
</style>
